import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseServices } from 'src/app/kuba/kuba.services';

import { ConfirmationService, SelectItem } from 'primeng/api';
import { KubaControlService } from '../../services/kuba-control.service';
import { Subscription } from 'rxjs';
import { Rights, Roles, Status } from 'src/app/_models';
import { KubaControlListDto } from '../../models/kubaControlListDto';

@Component({
  selector: 'app-kuba-control-list',
  templateUrl: './kuba-control-list.component.html',
  standalone: false
})
export class KubaControlListComponent implements OnInit {
  private readonly notifications = inject(NotificationService);
  kubaControlList: KubaControlListDto[];
  additionalData: any;
  statuses: SelectItem[];
  isAdministrateKc = false;

  private subscriptions: Subscription[] = [];
  constructor(
    public kubaControlService: KubaControlService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe(val => {
        this.additionalData = {
          fileName: val.CONTROL_OBJECT_LIST,
          header: 'Control Object List',
          businessId: BaseServices.BusinessId,
          cultureInfo: BaseServices.userCultureInfo(),
          columnNames: [
            { title: 'Object name', dataKey: 'ZoneName' },
            { title: 'Type Of Object', dataKey: 'ObjectType' },
            { title: 'Created On', dataKey: 'CreatedOn' },
            { title: 'Created By', dataKey: 'CreatorName' },
            { title: 'Status', dataKey: 'Status' },
            { title: 'Deviations In Followup', dataKey: 'ShowDeviation' }
          ]
        };
      })
    );
    this.subscriptions.push(
      this.translate.stream('SELECT_STATUS_DROP').subscribe(val => {
        this.statuses = [];
        this.statuses.push(
          { label: val.SELECT, value: null },
          { label: val.ACTIVE, value: Status.Active },
          { label: val.INACTIVE, value: Status.Inactive }
        );
      })
    );
  }

  //#region Page loading

  ngOnInit(): void {
    let controls = <KubaControlListDto[]>this.route.snapshot.data['list'];
    if (controls.length > 0) {
      this.kubaControlList = controls;
    }

    this.isAdministrateKc = this.checkAdminstrateKcRights();

    let kc = sessionStorage.getItem('checkParent');
    if (controls.length == 1) {
      if (kc === 'KUBA_CONTROL') {
        this.router.navigate(['../../list'], { relativeTo: this.route });
      } else {
        const kubaControl = controls[0];
        this.autoRedirectToKc(kubaControl);
      }
    }

    sessionStorage.setItem('checkParent', null);
    // To hide side menu bar
    document.querySelector('body').classList.remove('opened');
  }

  /**
   * Checks if the user has the rights to adminstrate the Controls
   * @returns Does the user have the rights?
   */
  checkAdminstrateKcRights(): boolean {
    if (+BaseServices.roleId === Roles.EDITOR) {
      return true;
    }

    const kcRights = Rights.ADMINISTRATE_KUBA_CONTROL;
    return BaseServices.checkUserRights(kcRights, BaseServices.UserRole);
  }

  /**
   * Navigates the user to the Control if thet have access to it.
   * @param kubaControl KC to navigate to
   */
  autoRedirectToKc(kubaControl: KubaControlListDto) {
    if (this.isAdministrateKc) {
      this.router.navigate(['../../details/' + kubaControl.Id], {
        relativeTo: this.route
      });
    } else {
      const userId = BaseServices.UserId;
      if (kubaControl.AssignedUserIds.find(kcu => kcu === userId)) {
        this.router.navigate(['../../details/' + kubaControl.Id], {
          relativeTo: this.route
        });
      }
    }
  }

  //#endregion

  deleteFoodSafety(FoodSafety: number) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.kubaControlService
            .deleteFoodSafety(FoodSafety)
            .subscribe(result => {
              this.subscriptions.push(
                this.kubaControlService
                  .getAllByBusinessId(BaseServices.BusinessId)
                  .subscribe(res => {
                    this.kubaControlList = res;
                    this.notifications.success('UI_NOTIFICATIONS.DELETED');
                  })
              );
            })
        );
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
